<div class="donut-card d-flex flex-column flex-md-row align-items-center">
    <div class="chart">
        <canvas #canvas></canvas>

        <div class="center">
            <div class="label">{{ props.totalLabel }}</div>
            <div class="total">{{ total | currency : props.currency}}</div>
        </div>
    </div>

    <div class="legend">
        <div class="legend-row" *ngFor="let s of segments">
            <p-checkbox class="d-flex align-items-center me-3" id="checkbox" name="checkbox" (ngModelChange)="updateCheckbox()" [(ngModel)]="s.show" [binary]="true" *ngIf="props.canHideSections" />
              <span
                      class="legend-dot"
                      [style.background]="s.color"
              ></span>
            <span class="legend-label">{{ s.label }}</span><span class="legend-value">{{ s.value | currency : props.currency }} </span>
        </div>
    </div>
</div>